// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KKzq","requiredAsterisk":"Info_requiredAsterisk__2NXjQ"};